import { render, staticRenderFns } from "./AcessoriesForm.vue?vue&type=template&id=3baae70b"
import script from "./AcessoriesForm.vue?vue&type=script&lang=js"
export * from "./AcessoriesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports